module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "asset"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Assets',
      "path": '/asset'
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.beforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.type === 'tractor') ? _c('TractorForm', {
    ref: "form",
    attrs: {
      "title": 'New Tractor'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'trailer') ? _c('TrailerForm', {
    ref: "form",
    attrs: {
      "title": 'New Trailer'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_vm._l((_vm.validationErrors), function(error) {
    return _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error.msg))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-simple btn-link btn-wd",
    on: {
      "click": function($event) {
        return _vm.toList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _vm._m(0)], 2)])])])]), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ddd231"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/asset/AssetAdd.vue
// module id = 689
// module chunks = 0